<template>
  <div>
    <p class="fw-bold">
      {{ trans(`subscription.classification_config.selector_type`) }}
    </p>
    <SelectorSelect
      v-model="selectedType"
      @change="ChangeSelector()"
    />
    <template v-if="selector">
      <SelectorTypeShow
        :key="counter"
        :selector="selector"
        :display-delete="false"
      />
    </template>
    <div

      class="d-flex flex-row-reverse"
    >
      <button
        type="button"
        class="btn btn-primary m-3"
        @click="Save()"
      >
        {{ trans(`subscription.classification_config.selectors.selector_save`) }}
      </button>
      <button
        v-if="displayDeleteButton"
        type="button"
        class="btn btn-danger m-3"
        @click="Remove()"
      >
        {{ trans(`subscription.classification_config.selectors.selector_remove`) }}
      </button>
      <slot />
    </div>
  </div>
</template>

<script>
import { addSelectorProperty, buildCompositeSelector, buildSelector, deleteSelector, searchParentAddChildSelector, selectorOperatorChange } from '@/employees/components/Selector/utilities/builder/selectorBuilder'
import { addSelectorReferences, deleteSelectorReferences } from '@/employees/components/Selector/utilities/adapter/selectorAdapter'
export default {
  name: 'SelectorBuilder',
  provide () {
    return {
      selectorContext: this.selectorContext,
      programId: this.programId,
    }
  },
  props: {
    selectedSelector: {
      required: false,
      type: Object,
      default: null,
    },
    selectorContext: {
      required: true,
      type: Object,
    },
    displayDeleteButton: {
      required: false,
      type: Boolean,
      default: true,
    },
    programId: {
      required: true,
      type: [Number, String],
    },
  },
  data () {
    return {
      selectedType: '',
      selector: null,
      counter: 0,
      first: false,
    }
  },
  created () {
    this.$root.$on('AddSelector', this.AddSelector)
    this.$root.$on('RemoveSelector', this.RemoveSelector)
    this.$root.$on('SelectorOperatorChange', this.SelectorOperatorChange)
    this.$root.$on('SelectorPropertyValueChange', this.SelectorPropertyValueAdd)
    this.$root.$on('SelectorPropertyValueAdd', this.SelectorPropertyValueAdd)
  },
  mounted () {
    if (this.selectedSelector && this.selectedSelector.selector) {
      this.selectedType = this.selectedSelector.selector.type
      this.selector = addSelectorReferences(this.selectedSelector.selector)
    } else {
      this.selectedType = 'composite'
      this.selector = buildCompositeSelector()
    }
  },
  destroyed () {
    // This will throw away the listeners
    this.$root.$off('AddSelector', this.AddSelector)
    this.$root.$off('RemoveSelector', this.RemoveSelector)
    this.$root.$off('SelectorOperatorChange', this.SelectorOperatorChange)
    this.$root.$off('SelectorPropertyValueChange', this.SelectorPropertyValueAdd)
    this.$root.$off('SelectorPropertyValueAdd', this.SelectorPropertyValueAdd)
    this.$store.dispatch('clear_groups_operators')
  },
  methods: {
    ChangeSelector () {
      this.selector = buildSelector(this.selectedType)
    },
    Save () {
      if (this.selector) {
        this.$emit('SaveSelector', {
          selector: deleteSelectorReferences(this.selector),
        })
      }
    },
    Remove () {
      this.$emit('RemoveSelector')
    },
    AddSelector (value) {
      if (this.selector) {
        searchParentAddChildSelector(this.selector, value[0], value[1], value[2])
        this.counter++
      }
    },
    RemoveSelector (value) {
      if (this.selector) {
        deleteSelector(this.selector, value[0])
      }
    },
    SelectorOperatorChange (value) {
      if (this.selector) {
        selectorOperatorChange(this.selector, value[0], value[1], value[2])
        this.counter++
      }
    },
    SelectorPropertyValueAdd (value) {
      if (this.selector) {
        addSelectorProperty(this.selector, value[0], value[1], value[2])
        this.counter++
      }
    },
  },
}
</script>
